export default class MediaUrlElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedImageUrl;
    this.savedAltText;
    this.savedCaption;
    this.activeElementId = null;
    this.activePosition = null;

    this.init();
  }

  init() {
    const action = (navigator.userAgent.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-image-url', this.buildRemoteUrlElement.bind(this));
    $(document).on(action, '.build-image-url', this.editElement.bind(this));
    $(document).on(action, '.submit-build-image-url', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-image-url', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-image-url', this.deleteElement.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-image-url" href="#"><i class="fa fa-picture-o"></i>Remote Url</a>';
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    this.addImageUrl($element.closest('.build-image-url-wrapper'),
                      this.savedImageUrl, this.savedAltText, this.savedCaption);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.finishEditing();
  }

  submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-image-url-wrapper');

    const imageUrl = $('.image-url-input').val();
    const altText = $('.alt-text-input').val();
    const caption = $('.caption-input').val();

    if (!this.validateElement(imageUrl, altText)) {
      this.displayError();
      return;
    }

    this.savedImageUrl = null;
    this.savedAltText = null;
    this.savedCaption = null;
    this.addImageUrl($element, imageUrl, altText, caption, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.save_page("Before Added Image Url Element");
  }

  validateElement(imageUrl, altText) {
    // super simple validation, just make sure both fields are present
    return imageUrl.trim().length && altText.trim().length;
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    $element.closest('.build-image-url-wrapper').remove();

    this.savedImageUrl = null;
    this.savedAltText = null;
    this.savedCaption = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Image Url Element");
  }

  editElement(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    let $element = $(event.currentTarget).closest('.build-image-url');
    let $image = $element.find('.image-url');
    let src = $image.attr('src');
    let alt = $image.attr('alt');
    let caption = $element.find('.image-caption').html();

    this.savedImageUrl = src;
    this.savedAltText = alt;
    this.savedCaption = caption;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');

    $element.replaceWith(this.imageUrlEditTemplate(src, alt, caption));
  }

  addImageUrl($element, imageUrl, altText, caption, id, position) {
    let imageUrlHtml =
      `<div id='${id || ''}' class='element row-fluid image-url-element build-image-url' data-position='${position}'>
        <img class='image-url' src="${imageUrl}" alt="${altText}" />
      </div>`;


    let $imageUrlHtml = $(imageUrlHtml);

    if (caption) {
      $imageUrlHtml.append(`<div class='image-caption'>${caption}</div>`);
    }

    if (imageUrl) {
      $element.replaceWith($imageUrlHtml);
    } else {
      $element.remove();
    }

  }

  buildRemoteUrlElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);
    link.closest('.button-bar, .bottom-button-bar').replaceWith(this.imageUrlEditTemplate());
  }

  displayError() {
    $('.build-image-url-wrapper .error').html("Image URL and Alt Text are required.");
  }

  imageUrlEditTemplate(imageUrl, altText, caption) {
    return `<div class="row-fluid build-image-url-wrapper">
        <div class='error'></div>
        <label>Enter Image URL</label>
        <input class='build-input image-url-input span12' type="text" value="${imageUrl || ""}">
        <label>Enter Image Alt Text</label>
        <input class='build-input alt-text-input span12' type="text" value="${altText || ""}">
        <label>Enter Image Caption (Optional)</label>
        <input class='build-input caption-input span12' type="text" value="${caption || ""}">
        <div class='editor-buttons'>
          <button class='delete-build-image-url delete'>Delete</button>
          <button class='cancel-build-image-url cancel'>Cancel</button>
          <button class='submit-build-image-url save'>Save</button>
        </div>
      </div>`
  }
}
